import { AxiosResponse } from "axios";

import { VenuePagesRow } from "@punchup/venues/data/venue_pages";
import { useMutation, UseMutateFunction } from "@tanstack/react-query";
import { useTixologi } from "@punchup/data/legacy/hooks";
import { setTixologiEventPublished } from "./setTixologiEventPublished";

export type SetEventPublishedParams = {
  eventId: string | number;
  published: boolean;
};

type UseSetEventPublishedReturn = {
  mutate: UseMutateFunction<
    AxiosResponse,
    Error,
    SetEventPublishedParams,
    unknown
  >;
  isPending: boolean;
};

/**
 * The venue dashboard's Publish / Unpublish action. It toasts and invalidates
 * nothing itself: the caller owns the one toast and the one refetch, so a click
 * never shows two toasts or refetches the show list twice.
 */
export function useSetEventPublished({
  venuePage,
}: {
  venuePage: VenuePagesRow;
}): UseSetEventPublishedReturn {
  const { tixologiData } = useTixologi({ id: venuePage.id, isComedian: false });

  const { mutate, isPending } = useMutation({
    mutationFn: ({ eventId, published }: SetEventPublishedParams) =>
      setTixologiEventPublished(eventId, published, tixologiData?.token),
  });
  return { mutate, isPending };
}
